(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["biket-events-hub"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(event){var button=event.target.closest('.bev__filters button');if(!button)return;var root=button.closest('.bev');root.querySelectorAll('.bev__filters button').forEach(function(b){b.classList.remove('is-active')});button.classList.add('is-active');root.querySelectorAll('.bev__card').forEach(function(card){card.hidden=button.dataset.filter!=='all'&&card.dataset.discipline!==button.dataset.filter})});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  if (!customElements.get('free-shipping-progress')) {
    class FreeShippingProgress extends HTMLElement {
      connectedCallback() {
        this.dataset.ready = 'true';
        this.threshold = Number(this.dataset.threshold || 0);
        this.cartUrl = this.dataset.cartUrl;
        this.refreshTimer = null;
        this.retryTimer = null;
        this.onCartEvent = () => this.scheduleRefresh(120);
        this.onCartSubmit = (event) => {
          const form = event.target.closest('form');
          if (!form || !form.action.includes('/cart/')) return;
          this.scheduleRefresh(600);
          clearTimeout(this.retryTimer);
          this.retryTimer = setTimeout(() => this.refresh(), 1400);
        };

        this.render(Number(this.dataset.cartTotal || 0), Number(this.dataset.cartCount || 0));

        this.cartEvents = [
          'cart:updated',
          'cart:refresh',
          'cart:change',
          'cart:item-added',
          'ajaxProduct:added',
          'product:added',
          'cart-drawer:updated'
        ];
        this.cartEvents.forEach((eventName) => document.addEventListener(eventName, this.onCartEvent));
        document.addEventListener('submit', this.onCartSubmit, true);

        this.cartObserver = new MutationObserver(() => this.scheduleRefresh(100));
        document.querySelectorAll('.cart-item-count-bubble').forEach((bubble) => {
          this.cartObserver.observe(bubble, { childList: true, characterData: true, subtree: true });
        });
      }

      disconnectedCallback() {
        clearTimeout(this.refreshTimer);
        clearTimeout(this.retryTimer);
        this.cartEvents?.forEach((eventName) => document.removeEventListener(eventName, this.onCartEvent));
        document.removeEventListener('submit', this.onCartSubmit, true);
        this.cartObserver?.disconnect();
      }

      scheduleRefresh(delay) {
        clearTimeout(this.refreshTimer);
        this.refreshTimer = setTimeout(() => this.refresh(), delay);
      }

      async refresh() {
        if (!this.cartUrl) return;
        try {
          const separator = this.cartUrl.includes('?') ? '&' : '?';
          const response = await fetch(`${this.cartUrl}${separator}t=${Date.now()}`, {
            credentials: 'same-origin',
            headers: { Accept: 'application/json' }
          });
          if (!response.ok) return;
          const cart = await response.json();
          this.render(Number(cart.total_price || 0), Number(cart.item_count || 0));
        } catch (error) {
          // Keep the last confirmed cart state if a refresh is interrupted.
        }
      }

      formatRand(cents) {
        const amount = Math.max(0, Math.ceil(cents / 100));
        const formatted = amount.toLocaleString('en-ZA').replace(/[\u00a0\u202f,]/g, ' ');
        return `R${formatted}`;
      }

      render(total, count) {
        if (!this.threshold) return;

        const remaining = Math.max(0, this.threshold - total);
        const progress = Math.min(100, Math.max(0, (total / this.threshold) * 100));
        const isEmpty = count === 0;
        const isUnlocked = total >= this.threshold;

        this.dataset.cartTotalLive = String(total);
        this.dataset.cartCountLive = String(count);
        this.dataset.state = isUnlocked ? 'unlocked' : (isEmpty ? 'empty' : 'remaining');

        const emptyMessage = this.querySelector('[data-free-shipping-empty]');
        const remainingMessage = this.querySelector('[data-free-shipping-remaining]');
        const unlockedMessage = this.querySelector('[data-free-shipping-unlocked]');
        const emptyAmount = emptyMessage?.querySelector('strong');
        const remainingAmount = remainingMessage?.querySelector('strong');
        const fill = this.querySelector('.biket-free-shipping__fill');

        if (emptyAmount) emptyAmount.textContent = this.formatRand(this.threshold);
        if (remainingAmount) remainingAmount.textContent = this.formatRand(remaining);
        if (emptyMessage) emptyMessage.hidden = !isEmpty;
        if (remainingMessage) remainingMessage.hidden = isEmpty || isUnlocked;
        if (unlockedMessage) unlockedMessage.hidden = !isUnlocked;
        if (fill) fill.style.setProperty('--biket-free-shipping-progress', `${progress}%`);

        this.toggleAttribute('data-unlocked', isUnlocked);
      }
    }

    customElements.define('free-shipping-progress', FreeShippingProgress);
  }

  } catch(e) { console.error(e); }
})();
})();
